import { Elements } from "@ts/core/Elements";
import { Utils } from "@ts/core/Utils";
import { SQLTool } from "./SQLTool";
import { LogTool } from "./LogTool";
import { UserTool } from "./UserTool";
import { CleaupTool } from "./CleanupTool";


export class AdminMenu {

    private menuElement: HTMLDivElement;

    public constructor() {
        this.menuElement = document.createElement('div');
        this.menuElement.className = 'adminMenu';
    }

    public get menuElementRef(): HTMLDivElement { return this.menuElement; }

    public close(): void {
        if (this.menuElement  ) {
            this.menuElement.remove();
        }
    }

    public render() {
        Elements.leftSidebar.appendChild(this.menuElement);
        const text = document.createElement('h3');
        text.innerText = 'Admin';
        this.menuElementRef.appendChild(text);

        this.add('SQL Backup',
            `Gör en backup av nuvarande SQL data`,
            'sql-backup',
            () => { SQLTool.backup(); });
        
        this.add('SQL Logg',
            'Visa en logg över SQL backuper',
            'sql-log', () => { SQLTool.viewLog(); });
        
        this.add('SQL återställ', 
            'Återställ SQL data från en backup',
            'sql-restore', () => {  SQLTool.restore(); });

        this.add('Visa logg',
            'Visa logg över händelser',
            'log-view', () => { LogTool.view() ; });

        this.add('Rensa logg',
            'Töm logg händelser',
            'log-clear', () => { LogTool.clear(); });

        this.add('Ny användare',
            'Addera ny användare',
            'user-add', () => { UserTool.add() ; });

        this.add('Redigera användare',
            'Redigera befintlig användare',
            'user-edit', () => { UserTool.edit(); });

        this.add('Ta bort användare',
            'Radera  befintlig användare',
            'user-delete', () => { UserTool.delete() ; });

        this.add('Ändra lösenord',
            'Ändra lösenordet för en befintlig användare',
            'user-password', () => { UserTool.password() ; });

        this.add('Städa',
            'Städa upp genom att radera sånt som inte längre används',
            'cleanup', () => { CleaupTool.cleanup(); } );
    }


    public add(title: string, help: string, action: string, cb: () => void): void {
        const btn = document.createElement('button');
        btn.id = action;
        btn.innerText = title;
        this.menuElement.appendChild(btn);
        btn.addEventListener('click', (e: Event) => {
            e.preventDefault();
            cb();
        });
        btn.addEventListener('mouseover', (e: Event) => {
            e.preventDefault();
            Elements.help.innerHTML = btn.disabled ? '' : help;
            Elements.help.style.top = `${btn.offsetTop}px`;
            Utils.forceRefresh(Elements.help);
        });
    }
}

